import { ref, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-37055ab8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "record-update-content"
};
const _hoisted_2 = {
  class: "record-item"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  key: 1
};
const __default__ = {
  name: 'RecordUpdate'
};
import { queryChangeRecord } from '@/api/payManage/appManage';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {},
    prodChnl: {
      type: String,
      default: ''
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const loading = ref(true);
    const timeList = ref([]);
    // 空的 validateForm 方法，用于保持接口一致性
    const validateForm = () => {
      return Promise.resolve();
    };
    // 过滤编辑记录
    const filterText = record => {
      if (!record.diffDtoList) return '--';
      try {
        const list = JSON.parse(record.diffDtoList) || [];
        const changes = list.map((diff, index) => {
          const name = diff.name || `字段${index + 1}`;
          return `${name}：${diff.oldValue} 变更为 ${diff.newValue}`;
        }).join('；');
        // 统一使用中文分号
        return `支付渠道：${record === null || record === void 0 ? void 0 : record.payChnl}；${changes}；变更人：${record.creator}`;
      } catch (error) {
        console.error('解析 diffDtoList 失败:', error);
        return '';
      }
    };
    // 初始化数据
    const initData = async () => {
      loading.value = true;
      try {
        const {
          dbtId,
          chnlFlag
        } = props.detailForm;
        const {
          code,
          data
        } = await queryChangeRecord({
          // bizId,
          bizType: '产品管理/支付配置',
          dbtId,
          chnlFlag,
          pageSize: 9999
        });
        if (code == '0') {
          timeList.value = data;
        }
      } catch (error) {} finally {
        loading.value = false;
      }
    };
    expose({
      validateForm
    });
    onMounted(async () => {
      // 查询日志列表
      initData();
    });
    return (_ctx, _cache) => {
      const _component_a_timeline_item = _resolveComponent("a-timeline-item");
      const _component_a_timeline = _resolveComponent("a-timeline");
      const _component_a_empty = _resolveComponent("a-empty");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createBlock(_component_a_spin, {
        spinning: loading.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [timeList.value.length > 0 && !loading.value ? (_openBlock(), _createBlock(_component_a_timeline, {
          key: 0,
          class: "record-timeline"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeList.value, (item, index) => {
            return _openBlock(), _createBlock(_component_a_timeline_item, {
              key: index
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.createDate), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(filterText(item)), 1)])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })) : timeList.value.length == 0 && !loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_a_empty)])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["spinning"]);
    };
  }
});